import { useState } from 'react';
import ApprovalsService from '../services/ApprovalsService';
import { errorText } from '../utils/format';

/** Approve and reject from inside the chat. `refresh` reloads the messages so the card shows the result. */
export function useApprovalActionsViewModel(refresh) {
  const [busyId, setBusyId] = useState('');
  const [feedback, setFeedback] = useState(null);

  const decide = async (id, action, grants) => {
    setBusyId(id);
    setFeedback(null);
    try {
      if (action === 'approve') await ApprovalsService.approve(id, grants);
      else await ApprovalsService.reject(id);
      setFeedback({ severity: 'success', text: action === 'approve' ? 'Approved.' : 'Rejected. Nothing was changed or sent.' });
    } catch (err) {
      setFeedback({ severity: 'error', text: errorText(err) });
    } finally {
      setBusyId('');
      if (refresh) refresh();
    }
  };

  return {
    busyId,
    feedback,
    clearFeedback: () => setFeedback(null),
    approve: (id, grants) => decide(id, 'approve', grants),
    reject: (id) => decide(id, 'reject'),
  };
}
